import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { ClubForm } from '../components/club';
import { useTranslation } from '../common/LocalizationProvider';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function AddClub() {
  const t = useTranslation();
  const navigate = useNavigate();

  return (
    <Page title={t('addClub_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('addClub')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/club', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <ClubForm />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
